export default __webpack_public_path__ + "static/media/characteristics.b7ed4c4c.png";